<template lang="pug">
  nav.top-nav-bar( role="navigation")
    .desktop-menu
      .container
        a.logo(:href="baseURL")
          img(src='/static/img/gleif-logo.svg' alt="GLEIF Logo")
        a.nav-item.default-bold(
          v-for="{title, route} in menuItems"
          :key="route"
          :href="buildURL(route)"
          target="_blank"
        ) {{title}}
        auth-control
    .mobile-menu
      .container
        .navbar-header
          .burger-menu(@click="showMenu", :class="{'menu-on': overlay}")
              .burger-bar
              .burger-bar
              .burger-bar
          a.logo(:href="baseURL")
            img(src='/static/img/gleif-logo.svg' alt="GLEIF Logo")
          .navbar-header__control
            auth-control
    transition( name="slide-fade")
      .overlay-menu(v-if="overlay")
        a.close(@click="closeMenu") &times;
        ul.header-nav
          li.nav-item(
            v-for="{title, route} in menuItems"
            :key="route"
            @click="closeMenu"
          )
            a(:href="buildURL(route)" target="_blank") {{title}}
        ul.footer-nav
          li.nav-item(
            v-for="{title, route} in footerItems"
            :key="route"
            @click="closeMenu")
            a(:href="buildURL(route)" target="_blank") {{title}}
</template>

<script>
import NavBars from '../../mixins/nav-bars'
import goToSearch from '../../mixins/go-to-search'
import authControl from '@/components/auth-components/authControl'
import { mapMutations, } from 'vuex'
import routerSearch from '../../mixins/router-search-mixin'
import { CLEAR_CHALLENGE, } from '@/store/modules/record/modules/challenge/mutations-types'
import { EventBus, } from '@/event-bus'

export default {
  components: {
    authControl,
  },
  mixins: [ NavBars, goToSearch, routerSearch, ],
  data () {
    return {
      subURL: 'lei-data',
    }
  },
  methods: {
    returnToSearch () {
      this.clearChallenge()
      EventBus.$emit('challenge-clear')
      this.routerSearch('')
    },

    ...mapMutations('record/challenge', {
      clearChallenge: CLEAR_CHALLENGE,
    }),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  img
    max-width 100%

  .top-nav-bar
    position relative
    width 100%
    background-color $default-color-middle-2
    border-bottom 1px solid $default-color-light-1

    .container
      justify-content space-between
      align-items center

    .desktop-menu
      display flex
      justify-content center

      .logo
        height fit-content
        padding 15px 0
        cursor pointer


      .container
        height 120px

      .general-link
        padding 10px 20px
        border 2px solid $default-color-light-1
        @media (max-width: $laptop)
          margin 7px

      .nav-item
        padding 15px 10px

        &:hover
          color $turquoise-color

    .mobile-menu
      display none
      justify-content center
      flex-wrap wrap

      .navbar-header
        width 100%
        display grid
        grid-template-columns repeat(3, 1fr)
        align-items center

        &__control
          justify-self end

        .logo
          justify-self: center;
          height 50px

          img
            height 50px
            width 50px

      .burger-menu
        position relative
        width 35px
        height 30px
        display flex
        flex-direction column
        justify-content space-around
        cursor pointer
        justify-self start

        .burger-bar
          width 100%
          background $default-color-bold
          height 2px

          &:last-child
            width 55%

    .overlay-menu
      z-index 100
      position fixed
      display flex
      flex-direction column
      justify-content space-between
      padding 1.5rem 2.5rem
      top 0
      background-color $default-color-bold-opacity
      width 100vw
      min-height 100vh

      .close
        position absolute
        top 2rem
        right 2.5rem
        font-size 3rem
        font-weight 500
        line-height 2rem

      .nav-item a, .close
        color $white-color

        &:hover
          color $info-color

      .header-nav
        .nav-item
          padding 0.9rem 0
          font-size 1.5rem
          color $white-color

      .footer-nav
        margin-top 40px

        .nav-item
          padding 0.5rem 0
          color $white-color

  @media (max-width: $laptop)
    .top-nav-bar
      .desktop-menu
        display none

      .mobile-menu
        display flex

  @media (max-width: $mobile)
    .top-nav-bar
      .overlay-menu
        padding 1.5rem
        padding-right 3rem

        .close
          right 2rem

  @media (max-width: $mobile-m)
    .top-nav-bar
      .overlay-menu
        .close
          top 1.5rem
          right 1rem
          font-size 2.75rem

        .header-nav
          .nav-item
            padding 0.55rem 0
            font-size 1.25rem

        .footer-nav
          .nav-item
            padding 0.5rem 0

  .slide-fade-enter-active
    opacity 1
    transition all .5s ease

  .slide-fade-leave-active
    opacity 0
    transition all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0)

  .slide-fade-enter, .slide-fade-leave-to
    transform translateX(-100vw)
    opacity 0
</style>



// WEBPACK FOOTER //
// src/components/layout-components/Navbar.vue